// -----------------------------------------------------------------------------
// <copyright file="edialog.component.ts" company="ecoInsight, Inc.">
// 	Copyright © ecoInsight, Inc. All rights reserved.
// </copyright>
// ------------------------------------------------------------------------------

import {
  AfterViewChecked,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';

import { GlobalService } from '../../services/global.service';

@Component({
  selector: 'fs-edialog',
  templateUrl: './edialog.component.html',
  styleUrls: ['./edialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class EDialogComponent implements AfterViewChecked, OnDestroy {
  @Output() public action: EventEmitter<any> = new EventEmitter<any>();
  @Input() public showCloseButton = true;
  public unsubscribe!: Subject<any>;
  public id: any;
  public title: any;
  showOverlay = true;
  constructor(
    private globalService: GlobalService,
    private router: Router,
  ) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.close();
      }
    });
  }

  ngAfterViewChecked(): void {
    const elements = document.getElementsByClassName('elight-box');
    if (elements.length > 1) {
      const parentNode = elements[1].parentNode;
      if (parentNode) {
        parentNode.removeChild(elements[1]);
      }
    }
  }

  public close(): void {
    this.action.emit({ action: 'CLOSE' });
    this.globalService.showOverlayInDialog.next(false);
  }

  public ngOnDestroy(): void {
    if (document.getElementsByClassName('edialog').length <= 2) {
      this.globalService.showOverlayInDialog.next(false);
    }
  }
}
